module.exports = __webpack_public_path__ + "static/media/overview1_0.5387fd1b.png";